import { Component } from '@angular/core';

@Component({
	selector: 'loading-component',
	templateUrl: './loading.component.html',
})
export class LoadingComponent {}
